import { render, staticRenderFns } from "./OnlinePayV2.vue?vue&type=template&id=3e0f222c&scoped=true&"
import script from "./OnlinePayV2.vue?vue&type=script&lang=ts&"
export * from "./OnlinePayV2.vue?vue&type=script&lang=ts&"
import style0 from "./OnlinePayV2.vue?vue&type=style&index=0&id=3e0f222c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f222c",
  null
  
)

export default component.exports